import React, { FC, useCallback, useState } from "react";
import styles from "../UploadReceipts.module.scss";
import { ActionCardSection } from "../../ActionCardSection";
import { UploadReceiptsSectionProps } from "../types";
import { Loader } from "../../../general/Loader";
import { pluralize } from "../../../../common/helpers/string";
import { TransactionsModal } from "../transactionsModal/TransactionsModal";
import { StandardModal } from "../../../general/Modal/Modal";
import { GetTransactionsResponseDto } from "../../../../common/dto/transactions/getTransactions/get-transactions-response.dto";
import { UploadReceiptsTransactionsTable } from "./UploadReceiptsTransactionsTable";

interface UploadReceiptsTransactionsSectionProps
    extends UploadReceiptsSectionProps {
    data?: GetTransactionsResponseDto;
    isLoading: boolean;
    onDetailsViewClosed: () => void;
}

export const UploadReceiptsTransactionsSection: FC<
    UploadReceiptsTransactionsSectionProps
> = ({ inOpened, isLoading, data, onDetailsViewClosed }) => {
    const [showAllTransactions, setShowAllTransactions] = useState(false);

    const total = data?.total ?? 0;
    const transactions = data?.data ?? [];

    const handleDetailsViewClosed = useCallback(() => {
        onDetailsViewClosed();
        setShowAllTransactions(false);
    }, [onDetailsViewClosed]);

    let sectionContent: React.ReactNode;
    let sectionTitle: React.ReactNode = (
        <>
            {total || "Some"} {pluralize("transaction", total)} require
            {total === 1 ? "s" : ""} a receipt
        </>
    );

    if (isLoading) {
        sectionContent = (
            <div>
                <Loader inline /> Loading...
            </div>
        );
    } else if (total > 0) {
        sectionContent = (
            <div className={styles.body}>
                <UploadReceiptsTransactionsTable
                    transactions={transactions}
                    onViewAll={() => setShowAllTransactions(true)}
                />
            </div>
        );
    } else {
        sectionContent = null;
        sectionTitle = <>You're all set with your receipts for now</>;
    }

    return (
        <>
            <ActionCardSection header={sectionTitle} inOpened={inOpened}>
                {sectionContent}
            </ActionCardSection>

            <StandardModal
                show={total > 0 && showAllTransactions}
                onHide={handleDetailsViewClosed}
                size="xl"
            >
                <TransactionsModal transactions={transactions} />
            </StandardModal>
        </>
    );
};
